// import { useEffect, useState } from "react";
import { RouterProvider } from "@tanstack/react-router";
// import Splash from "@/components/splash";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const App = (props: { router: any }) => {
  // TODO: since we use static for now, we don't need this logic
  // const [showSplash, setShowSplash] = useState(() => {
  //   return !localStorage.getItem("splashShown");
  // });
  // useEffect(() => {
  //   if (showSplash) {
  //     const timer = setTimeout(() => {
  //       localStorage.setItem("splashShown", "true");
  //       setShowSplash(false);
  //     }, 2000); // Display duration (2 seconds)
  //     return () => clearTimeout(timer);
  //   }
  // }, [showSplash]);

  return (
    <RouterProvider router={props.router} />
  );
};
